<template>
  <div class="menu-item-r">
    <div class=" showcase-list">
      <section class="tips">
        <el-button class="export-btn" icon="el-icon-circle-plus-outline" type="primary" size="mini" @click="createHotspot">{{
          $t('Add Hotspot')
        }}</el-button>
      </section>

      <el-table :data="tableData" style="width: 100%; margin: 30px auto">
        <el-table-column :label="$t('Scene Image')" align="center">
          <template slot-scope="scope">
            <img class="scene-image" :src="scope.row.url" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('Hotspot Amount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.hotImagePointList.length }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('Binding Product')" align="center" width="440">
          <template slot-scope="scope">
            <div class="product-column" :class="{ isExpand: !scope.row.isCollapes }">
              <div class="product-container">
                <div class="product-item" v-for="item in scope.row.hotImagePointList" :key="item.id">
                  <img class="p-img" :src="item.productImgUrl.split(',')[0]" />
                  <div class="p-description">{{ item.productName }}</div>
                </div>
              </div>

              <div class="action-btn" @click="toogle(scope.row)" v-if="scope.row.hotImagePointList.length > 1">
                <i class="el-icon-arrow-up" :class="{ 'el-icon-arrow-down': scope.row.isCollapes }"></i
                ><span>{{ scope.row.isCollapes ? $t('Expand') : $t('Collapes') }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="formatedDate" :label="$t('Hotspot Created Date')" align="center"> </el-table-column>
        <el-table-column :label="$t('status')" align="center">
          <template slot-scope="scope">
            <div class="tag completed" v-if="scope.row.recommend">{{ $t('On Stage') }}</div>
            <div class="tag pending" v-if="!scope.row.recommend">{{ $t('Not On Stage') }}</div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('Action')" width="100" align="center">
          <template slot-scope="scope">
            <el-popover placement="top-start" width="210" :ref="`popover-${scope.$index}`">
              <div class="txt-deleting">
                <i class="hotspot-del el-icon-warning"></i> <span>{{ $t('Are you sure you want to delete this hotspot?') }}</span>
              </div>
              <div style="text-align: right; margin: 10px 0 0 0">
                <el-button size="mini" type="text" @click="scope._self.$refs[`popover-${scope.$index}`].doClose()">{{
                  $t('order.Cancel')
                }}</el-button>
                <el-button type="primary" size="mini" @click="del(scope)">{{ $t('order.Confirm') }}</el-button>
              </div>
              <el-button type="text" slot="reference" size="small">{{ $t('Delete') }}</el-button>
            </el-popover>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="goDetail(scope.row.id)" type="text" size="small">{{ $t('editor') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="bl-container">
      <el-pagination
        v-if="tableData.length > 0"
        background
        @current-change="handlePageChange"
        :page-size="pagination.pageRows"
        :current-page.sync="pagination.pageNum"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
        class="bl-page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getHotImageList, deleteHotImage } from '@/api'
const pageRows = 6
export default {
  data() {
    return {
      pagination: {
        pageNum: 1,
        pageRows: pageRows,
        total: 0
      },
      tableData: []
    }
  },

  mounted() {
    this.getList()
  },

  methods: {

    getList() {
      const loading = this.$loading()
      getHotImageList({
        pageNum: this.pagination.pageNum,
        pageRows: this.pagination.pageRows
      }).then(res => {
        this.pagination.total = res.data.data.total
        this.tableData = res.data.data.list.map(item => {
          item.isCollapes = true
          item.formatedDate = this.$funcs.dateFormat(item.updateTime)
          return item
        })
        loading.close()
      })
    },

    handlePageChange(val) {
      this.pagination.pageNum = val
      this.getList()
    },

    createHotspot() {
      this.$router.push('/hotspot-detail/step1')
    },

    toogle(item) {
      item.isCollapes = !item.isCollapes
    },

    goDetail(id) {
      this.$router.push('/hotspot-detail/step1/' + id)
    },

    del(scope) {
      console.log(scope.row.id)
      deleteHotImage({
        id: scope.row.id
      }).then(() => {
        scope._self.$refs[`popover-${scope.$index}`].doClose()
        this.getList()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-item-r
  padding-bottom 30px

.txt-deleting
  display flex
  span
    display block
    padding-left 8px
    word-break break-word
    line-height 1.5
.hotspot-del.el-icon-warning
  color #FAAD14
  line-height 1.6
.showcase-list
  margin 30px auto
  max-width 100%
  .tips
    text-align right
  .scene-image
    width 160px
    height 88px
    object-fit cover
.tag
  min-width 52px
  height 19px
  border-radius 2px
  text-align center
  font-size 12px
  color $color-white
  display inline-block
  line-height 1.5
  margin-left 10px
  padding 0 10px
.tag.completed
  background $color-blue-48
.tag.pending
  background $color-red-78
.product-item
  display flex
  align-items flex-start
  justify-content space-between
  padding 10px
  background $color-gray-fa
  width 340px
  height 80px
  overflow hidden
  margin-bottom 10px
  &:last-child
    margin-bottom 0
  .p-img
    width 60px
    height 60px
    object-fit cover
  .p-description
    width 244px
    text-align left
.product-column
  position relative
  width 410px
  max-height 81px
  transition 0.5s all
  &.isExpand
    max-height 850px
    transition 0.5s all
  .action-btn
    position absolute
    top 2px
    right 35px
    color $color-main
    cursor pointer
    display flex
    flex-direction column
</style>
